import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload2",
  "use": "icon-upload2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upload2\"><path d=\"M983.168 708.16l-46.4 44.032L832 641.92V1024h-64V638.4l-104.384 114.112-47.232-43.2L796.864 512l186.304 196.16zM512 832h64v-64H64v-64h448v-64H64V128h832v384h64V64H0v768h448v64H256v64h448v-64H512v-64z\" fill=\"\" p-id=\"4369\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-upload2.svg
// module id = ClZx
// module chunks = 177